import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Process from "@/pages/Process";
import ConditionGuide from "@/pages/ConditionGuide";
import Returns from "@/pages/Returns";
import Sustainability from "@/pages/Sustainability";
import Contact from "@/pages/Contact";
import Products from "@/pages/Products";
import Legal from "@/pages/Legal";
import Privacy from "@/pages/Privacy";
import About from "@/pages/About";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/process" element={<Process />} />
            <Route path="/condition-guide" element={<ConditionGuide />} />
            <Route path="/returns" element={<Returns />} />
            <Route path="/sustainability" element={<Sustainability />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              fontFamily: "IBM Plex Sans, sans-serif",
              border: "1px solid #e5e7eb",
              borderRadius: "4px",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
